enum LicenseStatus {
  NotFound = "NotFound",
  Invalid = "Invalid",
  Expired = "Expired",
  Valid = "Valid",
}

export { LicenseStatus };
